import styled from "styled-components";

export const SingleMaterialWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;
